// @flow
import * as React from 'react';
import { connectWS } from 'speed-js-react';
import { type WebSocketClient } from 'speed-js-core';
import { FormattedMessage } from 'react-intl';
import WarningDialog from 'speed-js-react-web/src/components/dialogs/modal/WarningDialog';


type Props = {
    ws: WebSocketClient,
};

type State = {
    connected: boolean,
};


@connectWS
class NetworkIndicator extends React.Component<Props, State> {
    static defaultProps = {
        ws: {},
    };

    timeout: ?TimeoutID = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            connected: true,
        };
    }

    componentDidMount() {
        const { ws } = this.props;

        this.setTimeout();

        ws.onOpen(this.handleOpen);
        ws.onClose(this.handleClose);
    }

    componentWillUnmount() {
        const { ws } = this.props;
        ws.removeOnOpen(this.handleOpen);
        ws.removeOnClose(this.handleClose);
    }

    setTimeout = (ms: number = 5000) => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.setState({
                connected: false,
            });
        }, ms);
    };

    handleOpen = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.setState({
            connected: true,
        });
    };

    handleClose = () => this.setTimeout(2000);

    render() {
        const { connected } = this.state;
        if (connected || connected === null) {
            return null;
        }

        return (
            <WarningDialog message={(
                <FormattedMessage
                    id="no-internet-message"
                    defaultMessage="No connection. Check your internet and if the problem still
                persists contact your system administrator."
                />
            )
            }
            />
        );
    }
}

export default NetworkIndicator;
